export enum TransactionTypes {
    All = 1,
    Unreconciled,
    Reconciled
}
